module.exports = __webpack_public_path__ + "img/parent.6bc5e8e3.svg";